import { Bold } from '@tiptap/extension-bold';
import { BulletList } from '@tiptap/extension-bullet-list';
import Collaboration from '@tiptap/extension-collaboration';
import CollaborationCursor from '@tiptap/extension-collaboration-cursor';
import { Document } from '@tiptap/extension-document';
import { Image } from '@tiptap/extension-image';
import { Italic } from '@tiptap/extension-italic';
import { Link } from '@tiptap/extension-link';
import { ListItem } from '@tiptap/extension-list-item';
import { OrderedList } from '@tiptap/extension-ordered-list';
import { Paragraph } from '@tiptap/extension-paragraph';
import { Placeholder } from '@tiptap/extension-placeholder';
import { Text as TextExtension } from '@tiptap/extension-text';
import { Underline } from '@tiptap/extension-underline';
import { useMemo } from 'react';
import * as Y from 'yjs';

import { CreatedAtExtension, CreatedByUserExtension, EditedAtExtension, EditedByUserExtension, Repeatable, TopicNode } from './index';

// import { UploadImage } from './upload-image';

export interface ExtensionConfig {
	yjsDoc: Y.Doc;
	yjsAwareness: any;
	provider: any;
	currentUser: {
		id: string;
		display_name: string;
	};
	userColor: string;
	onUploadFile?: (file: File) => Promise<string | null>;
	placeholder: string;
}

export function useEditorExtensions(config: ExtensionConfig) {
	// const hasImageUploads = useFeatureFlag('editor-image-uploads');
	// const hasAdvancedFormatting = useFeatureFlag('editor-advanced-formatting');

	return useMemo(
		() => [
			Document,
			Paragraph,
			TextExtension,
			Bold,
			Italic,
			Underline,
			Link,
			Image.configure({ inline: true }),
			BulletList,
			OrderedList,
			ListItem,

			Collaboration.configure({
				document: config.yjsDoc,
				field: 'default',
			}),

			CollaborationCursor.configure({
				provider: config.provider,
				user: {
					name: config.currentUser.display_name,
					color: config.userColor,
				},
			}),

			CreatedByUserExtension.configure({
				userId: config.currentUser.id,
				saveAttribution: true,
			}),

			EditedByUserExtension.configure({
				userId: config.currentUser.id,
				saveAttribution: true,
			}),

			CreatedAtExtension.configure({
				saveTimestamp: true,
			}),

			EditedAtExtension.configure({
				saveTimestamp: true,
			}),

			Placeholder.configure({
				placeholder: config.placeholder,
			}),

			// Repeatable extension for generic blocks (paragraph, heading, lists, etc.)
			Repeatable.configure({
				userId: config.currentUser.id,
			}),

			// TopicNode with repeat support
			TopicNode.configure({
				userId: config.currentUser.id,
			}),

			// ...(hasImageUploads && config.onUploadFile ? [UploadImage.configure({ onUploadFile: config.onUploadFile })] : []),
			// ...(hasAdvancedFormatting ? [Strike, Code, Highlight] : []),
		],
		[
			config.yjsDoc,
			config.provider,
			config.currentUser.id,
			config.currentUser.display_name,
			config.userColor,
			config.placeholder,
			// hasImageUploads,
			// hasAdvancedFormatting,
		]
	);
}
